import {
  getDailyCarbsIntakeGoalInGramProfileSelect
} from '../../profile/redux/selectors/get-daily-carbs-intake-goal-in-gram'
import {
  getDailyProteinIntakeGoalInGramProfileSelect
} from '../../profile/redux/selectors/get-daily-protein-intake-goal-in-gram'
import {
  getDailyFatIntakeGoalInGramProfileSelect
} from '../../profile/redux/selectors/get-daily-fat-intake-goal-in-gram'
import {
  updateDailyCarbsIntakeGoalInGramProfileAction
} from '../../profile/redux/actions/update-daily-carbs-intake-goal-in-gram'
import {
  updateDailyProteinIntakeGoalInGramProfileAction
} from '../../profile/redux/actions/update-daily-protein-intake-percentage-goal-in-gram'
import {
  updateDailyFatIntakeGoalInGramProfileAction
} from '../../profile/redux/actions/update-daily-fat-intake-intake-goal-in-gram'
import {
  getDailyCarbsIntakePercentageGoalProfileSelect
} from '../../profile/redux/selectors/get-daily-carbs-intake-percentage-goal'
import {
  getDailyFatIntakePercentageGoalProfileSelect
} from '../../profile/redux/selectors/get-daily-fat-intake-percentage-goal'
import {
  getDailyProteinIntakePercentageGoalProfileSelect
} from '../../profile/redux/selectors/get-daily-protein-intake-percentage-goal'
import {
  updateDailyCarbsIntakeGoalPercentageProfileAction
} from '../../profile/redux/actions/update-daily-carbs-intake-percentage-goal'
import {
  updateDailyProteinIntakePercentageGoalProfileAction
} from '../../profile/redux/actions/update-daily-protein-intake-percentage-goal'
import {
  updateDailyFatIntakeGoalPercentageProfileAction
} from '../../profile/redux/actions/update-daily-fat-intake-percentage-goal'
import { MACRONUTRIENT } from './macros'

export const MACRONUTRIENT_TO_DAILY_INTAKE_IN_GRAM_SELECT = {
  [MACRONUTRIENT.CARBS]: getDailyCarbsIntakeGoalInGramProfileSelect,
  [MACRONUTRIENT.PROTEIN]: getDailyProteinIntakeGoalInGramProfileSelect,
  [MACRONUTRIENT.FAT]: getDailyFatIntakeGoalInGramProfileSelect
}

export const MACRONUTRIENT_TO_DAILY_INTAKE_IN_PERCENTAGE_SELECT = {
  [MACRONUTRIENT.CARBS]: getDailyCarbsIntakePercentageGoalProfileSelect,
  [MACRONUTRIENT.PROTEIN]: getDailyProteinIntakePercentageGoalProfileSelect,
  [MACRONUTRIENT.FAT]: getDailyFatIntakePercentageGoalProfileSelect
}

export const MACRONUTRIENT_TO_DAILY_INTAKE_IN_GRAM_ACTION = {
  [MACRONUTRIENT.CARBS]: updateDailyCarbsIntakeGoalInGramProfileAction,
  [MACRONUTRIENT.PROTEIN]: updateDailyProteinIntakeGoalInGramProfileAction,
  [MACRONUTRIENT.FAT]: updateDailyFatIntakeGoalInGramProfileAction
}

export const MACRONUTRIENT_TO_DAILY_INTAKE_IN_PERCENTAGE_ACTION = {
  [MACRONUTRIENT.CARBS]: updateDailyCarbsIntakeGoalPercentageProfileAction,
  [MACRONUTRIENT.PROTEIN]: updateDailyProteinIntakePercentageGoalProfileAction,
  [MACRONUTRIENT.FAT]: updateDailyFatIntakeGoalPercentageProfileAction
}
